import React from "react";
import { useTranslation } from "react-i18next";

const DeliveryInformation = () => {
  const { t } = useTranslation();

  const renderTextWithLinks = (text) => {
    if (!text) return null;
    const regex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})|(\+65\s?\d{4}\s?\d{4})/g;
    const parts = text.split(regex);
    return parts.map((part, index) => {
      if (part === undefined || part === "") return null;
      
      const isEmail = part.includes("@");
      const isWhatsApp = part.startsWith("+65");
      
      if (isEmail) {
        return (
          <a key={index} href={`mailto:${part}`}>
            {part}
          </a>
        );
      }
      if (isWhatsApp) {
        const cleanNum = part.replace(/\s+/g, "");
        return (
          <a key={index} href={`https://wa.me/${cleanNum.replace("+", "")}`}>
            {part}
          </a>
        );
      }
      return part;
    });
  };

  const pageStyle = {
    maxWidth: "800px",
    margin: "20px auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
    color: "#dfbd69",
    borderRadius: "10px",
    backgroundColor: "transparent",
  };
  const headingStyle = {
    color: "#dfbd69",
    textAlign: "center",
    marginBottom: "20px",
  };

  const sectionHeadingStyle = {
    color: "#dfbd69",
    fontSize: "1.2rem",
    margin: "15px 0",
  };

  return (
    <div style={pageStyle}>
      <h1 style={headingStyle}>{t("deliveryPage.title")}</h1>

      <p>{t("deliveryPage.introText")}</p>

      <h2 style={sectionHeadingStyle}>{t("deliveryPage.areasTitle")}</h2>
      <p>{renderTextWithLinks(t("deliveryPage.areasText"))}</p>

      <h2 style={sectionHeadingStyle}>{t("deliveryPage.timeframeTitle")}</h2>
      <ul>
        <li>{t("deliveryPage.timeframeList1")}</li>
        <li>{t("deliveryPage.timeframeList2")}</li>
        <li>{t("deliveryPage.timeframeList3")}</li>
      </ul>

      <h2 style={sectionHeadingStyle}>{t("deliveryPage.feesTitle")}</h2>
      <ul>
        <li>{t("deliveryPage.feesList1")}</li>
        <li>{t("deliveryPage.feesList2")}</li>
      </ul>

      <h2 style={sectionHeadingStyle}>{t("deliveryPage.contactlessTitle")}</h2>
      <p>{t("deliveryPage.contactlessText")}</p>

      <h2 style={sectionHeadingStyle}>{t("deliveryPage.failedTitle")}</h2>
      <p>{t("deliveryPage.failedIntro")}</p>
      <ul>
        <li>{t("deliveryPage.failedList1")}</li>
        <li>{t("deliveryPage.failedList2")}</li>
      </ul>
      <p>{t("deliveryPage.failedOutro")}</p>

      <h2 style={sectionHeadingStyle}>{t("deliveryPage.trackingTitle")}</h2>
      <p>{renderTextWithLinks(t("deliveryPage.trackingText"))}</p>

      <h2 style={sectionHeadingStyle}>{t("deliveryPage.damagedTitle")}</h2>
      <p>{renderTextWithLinks(t("deliveryPage.damagedText"))}</p>

      <h2 style={sectionHeadingStyle}>{t("deliveryPage.contactTitle")}</h2>
      <p>{renderTextWithLinks(t("deliveryPage.contactText"))}</p>

      <p style={{ textAlign: "center", marginTop: "30px", fontSize: "0.9rem" }}>
        {t("deliveryPage.copyright")}
      </p>
    </div>
  );
};

export default DeliveryInformation;
